import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // local
import sessionStorage from 'redux-persist/lib/storage/session'; // session
import thunk from 'redux-thunk';

import chapterReducer from './reducers/chapterSlice';
import txnReducer from './reducers/transactionSlice';
import userReducer from './reducers/userSlice';
import insDetailsReducer from './reducers/insuranceDetailsSlice';

// config for local storage
const persistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['chapter', 'user'],
};
// config for session storage
const sessionPersistConfig = {
  // version: 1,
  key: 'pos',
  storage: sessionStorage,
  debug: true,
};

const rootReducer = combineReducers({
  chapter: persistReducer(sessionPersistConfig, chapterReducer),
  user: persistReducer(sessionPersistConfig, userReducer),
  txn: txnReducer,
  insDetails: insDetailsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(thunk),
});

export const persistor = persistStore(store);
